import { render, staticRenderFns } from "./Daka.vue?vue&type=template&id=6f40d1fd&"
import script from "./Daka.vue?vue&type=script&lang=js&"
export * from "./Daka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports